import { CartServiceBase } from '@/services/cart/CartServiceBase';
import { DefaultCartApiWrapper } from '@/services/cart/api/DefaultCartApiWrapper';
import { ConfigService } from '@/services/ConfigService';
import { ApiService } from '@/services/ApiService';
import Vue from 'vue';
import { CartEvents } from '@/services/cart/model/cart-events';
import { OrderDto } from '@eurogast/hub-client-typescript';
import Store from '@/store';
import { Cart } from '@/services/cart/model/cart';
import MatomoRefreshCart from '@/matomo/MatomoRefreshCart';
import MatomoOrderSubmit from '@/matomo/MatomoOrderSubmit';

export class DefaultCartService extends CartServiceBase {
    private static instance = new DefaultCartService();
    protected api: DefaultCartApiWrapper;

    private constructor() {
        super(DefaultCartApiWrapper.singleton());
    }

    public static singleton(): DefaultCartService {
        return this.instance;
    }

    protected async submitOrder(): Promise<OrderDto> {
        const state = Store.state.commonOrderDetail;
        const defaultOrderState = Store.state.defaultOrderDetail;

        const orderDto = await this.api.submitOwnShoppingCart(
          ConfigService.getTenant(),
          ConfigService.currentCustomerId,
          {
              deliverySlot: defaultOrderState.deliverySlot,
              deliveryAddressExternalId: state.deliveryAddress.externalId,
              unloadingArea: state.unloadingArea,
              notes: state.notes,
              customerOrderId: state.customerOrderId
          }
        );

        MatomoOrderSubmit.from(orderDto, this.getAllItems()).publish();

        return orderDto;
    }

    /**
     * triggers an event to add all products to the cart
     */
    public triggerPutAllItemsEvent() {
        Vue.prototype.$events.$emit(CartEvents.ADD_ALL_TO_CART);
        this.putAllItems();
    }
    /**
     * Puts all items from the local store state into the backend cart.
     * If the current user is not authenticated, they are redirected to
     * the login page.
     */
    private putAllItems() {
        if (!ConfigService.hasAccessToken()) {
            document.location.href = '/auth/login';
            return;
        }
        this.api.addAllItemsToOwnShoppingCart(
            ConfigService.getTenant(),
            ConfigService.currentCustomerId,
            this.getAllItems()
        )
            .then((cart) => this.storeCartState(cart))
            .catch(ApiService.defaultErrorHandler);
    }

    protected storeCartState(resCart: Cart) {
        super.storeCartState(resCart);
        MatomoRefreshCart.from(this.getAllItems(), this.totalPrice).publish();
    }
}
